import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from 'client/common/components/chip/Chip'
import { CrossIcon } from 'chemistry'
import { useSelector } from 'react-redux'
import { getLabel } from '../utilsFilters'
import { BRICO } from 'client/common/utils'

const ActiveFiltersChips = ({ collection, onRemove }) => {
  const showNewFilterLabels = useSelector(({ data }) => data?.flags?.showNewFilterLabels)
  const format = useSelector(({ data }) => data?.format)
  return Object.entries(collection).map(([key, values]) =>
    values.map(value => (
      <Chip
        as='button'
        key={`${key}-${value.value}`}
        onClick={() =>
          onRemove({
            title: key,
            item: {
              checked: false,
              value
            },
            filterPosition: 'side'
          })
        }
      >
        {format === BRICO && showNewFilterLabels ? getLabel(value.label) : value.label}
        <CrossIcon lineHeight='inherit' cursor='pointer' />
      </Chip>
    ))
  )
}

ActiveFiltersChips.propTypes = {
  collection: PropTypes.array,
  onRemove: PropTypes.func
}

export default ActiveFiltersChips
